import Input from "components/common/input";
import { memberInitialValues, memberSchema } from "constants/members";
import { ErrorMessage, Formik, useFormikContext } from "formik";
import SelectComponent from "components/common/select";
import DateInput from "components/common/date-picker";
import {
  CONDITIONS,
  EMERGENCY_CONTACT_RELATIONSHIPS,
  GENDER,
  Housing_Navigator,
  initialMetaForTable,
  MARTIAL_STATUSES,
  normalizeInput,
  POPULATION_FOCUSES,
  RACES,
  US_STATES,
  PROGRAM_STATUS_OPTIONS,
  CALAIM_PROGRAMS,
  alertTypes,
} from "constants/common";
import AsyncSelect from "components/common/select/AsyncSelect";
import { useCallback, useEffect, useState } from "react";
import {
  getCaseManagers,
  getCities,
  getCounties,
  getHealthPlans,
  getLandlords,
  getProperties,
  getStates,
  getUnits,
  getZipCodes,
} from "containers/policies/api";
import {
  useDebouncedCaseManagerDataCallback,
  useDebouncedCitiesDataCallback,
  useDebouncedCountiesDataCallback,
  useDebouncedHealthPlansDataCallback,
  useDebouncedHousingNavigatorDataCallback,
  useDebouncedLandloadDataCallback,
  useDebouncedPropertiesDataCallback,
  useDebouncedStatesDataCallback,
  useDebouncedUnitsDataCallback,
  useDebouncedZipCodesDataCallback,
} from "utils/debouncedHelper";
import { capitalizeName, disableFutureDates, sortData } from "utils/common";
import { getUserByType } from "containers/users/api";
import { toast } from "react-toastify";
import CustomToast from "components/common/custom-toast";
const AddQuestionForm = ({
  handleQuestionSubmittion,
  handleClose,
  selectedMember,
}) => {
  const [healthPlansList, setHealthPlansList] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const [countiesList, setCountiesList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [housingNavigator, setHousingNavigator] = useState([]);
  const [caseManger, setCaseManger] = useState([]);
  const [caseManagersList, setCaseManagersList] = useState([]);
  const [propertiesList, setPropertiesList] = useState([]);
  const [unitsList, setUnitsList] = useState([]);
  const [landlordsList, setLandlordsList] = useState([]);
  const [zipCodesList, setZipCodesList] = useState([]);
  const [mailingZipCodesList, setMailingZipCodesList] = useState([]);
  const [mailingStatesList, setMailingStatesList] = useState([]);
  const [mailingCountiesList, setMailingCountiesList] = useState([]);
  const [mailingCitiesList, setMailingCitiesList] = useState([]);
  const mailingAddress = selectedMember?.addresses?.find(
    (addr) => addr.address_type === "mailing",
  );
  const homeAddress = selectedMember?.addresses?.find(
    (addr) => addr.address_type === "home",
  );

  const fetchStates = async () => {
    const result = await getStates({
      ...initialMetaForTable,
    });
    if (result?.states) {
      const data = result?.states;
      data.sort((a, b) => a.name.localeCompare(b.name));
      setStatesList(data);
      setMailingStatesList(data);
    }
  };

  const fetchCounties = async (stateId) => {
    const result = await getCounties({
      ...initialMetaForTable,
      state_id: stateId,
    });
    if (result["counties"]) {
      const data = result?.counties;
      setCountiesList(sortData(data));
    }
  };
  const fetchCities = async (stateId, countyId) => {
    const result = await getCities({
      ...initialMetaForTable,
      state_id: stateId,
      county_id: countyId,
    });
    if (result["cities"]) {
      const data = result?.cities;
      setCitiesList(sortData(data));
    }
  };
  const fetchMailingCounties = async (stateId) => {
    const result = await getCounties({
      ...initialMetaForTable,
      state_id: stateId,
    });
    if (result["counties"]) {
      const data = result?.counties;
      setMailingCountiesList(sortData(data));
    }
  };
  const fetchMailingCities = async (stateId, countyId) => {
    const result = await getCities({
      ...initialMetaForTable,
      state_id: stateId,
      county_id: countyId,
    });
    if (result["cities"]) {
      const data = result?.cities;
      setMailingCitiesList(sortData(data));
    }
  };
  const fetchZipCodes = async (stateId, countyId, cityId) => {
    const result = await getZipCodes({
      ...initialMetaForTable,
      state_id: stateId,
      county_id: countyId,
      city_id: cityId,
    });
    if (result["zip_codes"]) {
      setZipCodesList(result.zip_codes);
    }
  };

  const fetchMailingZipCodes = async (stateId, countyId, cityId) => {
    const result = await getZipCodes({
      ...initialMetaForTable,
      state_id: stateId,
      county_id: countyId,
      city_id: cityId,
    });
    if (result["zip_codes"]) {
      setMailingZipCodesList(result.zip_codes);
    }
  };

  const fetchHealthPlan = async (searchString) => {
    const result = await getHealthPlans({
      ...initialMetaForTable,
      search: searchString,
    });

    if (result["health_plans"]) {
      const data = result?.health_plans;
      const activePlans = data.filter((plan) => plan.status === "active");

      setHealthPlansList(sortData(sortData(activePlans)));
    }
  };

  const fetchUserTypes = async () => {
    try {
      const response = await getUserByType({
        ...initialMetaForTable,
        user_type: "housing_navigator",
      });
      if (response?.housing_navigators) {
        setHousingNavigator(sortData(response.housing_navigators));
      }
    } catch (error) {
      console.error("Fetching user types failed:", error);
    }
  };
  const fetchUserType = async () => {
    try {
      const response = await getUserByType({
        ...initialMetaForTable,
        user_type: "case_manager",
      });
      if (response?.cs_managers) {
        setCaseManger(response.cs_managers);
      }
    } catch (error) {
      console.error("Fetching user types failed:", error);
    }
  };
  useEffect(() => {
    fetchStates();
    fetchUserTypes();
    fetchUserType();
  }, []);
  const fetchCaseManagers = async (searchString) => {
    try {
      const result = await getCaseManagers({
        ...initialMetaForTable,
        search: searchString,
      });

      if (result && result.users) {
        const data = result.users;
        setCaseManagersList(data);
      } else if (result && Array.isArray(result)) {
        setCaseManagersList(result);
      } else {
        console.log("Unexpected case managers response structure:", result);
        setCaseManagersList([]);
      }
    } catch (error) {
      console.error("Error fetching case managers:", error);
      setCaseManagersList([]);
    }
  };

  const fetchProperties = async (searchString) => {
    try {
      const result = await getProperties({
        ...initialMetaForTable,
        search: searchString,
      });

      if (result && result.housing_databases) {
        console.log("properties", result.housing_databases);
        const data = result.housing_databases;
        setPropertiesList(data);
      } else {
        console.log("Unexpected properties response structure:", result);
        setPropertiesList([]);
      }
    } catch (error) {
      console.error("Error fetching properties:", error);
      setPropertiesList([]);
    }
  };

  const fetchUnits = async (propertyId, inputValue) => {
    try {
      const result = await getUnits({
        ...initialMetaForTable,
        propertyId: propertyId,
        search: inputValue,
      });
      if (result?.housing_database) {
        const data = result?.housing_database;
        setUnitsList(data?.units);
        setLandlordsList(data?.key_contacts);
      }
    } catch (error) {
      console.error("Error fetching units:", error);
      setUnitsList([]);
    }
  };

  useEffect(() => {
    fetchHealthPlan();
    fetchStates();
    fetchCaseManagers();
    fetchProperties();
  }, []);

  useEffect(() => {
    if (selectedMember?.home_state?.id) {
      fetchCounties(selectedMember.home_state?.id);
    }
  }, [selectedMember]);

  useEffect(() => {
    if (selectedMember?.home_state?.id && selectedMember?.home_county?.id) {
      fetchCities(
        selectedMember.home_state?.id,
        selectedMember.home_county?.id,
      );
    }
  }, [selectedMember]);

  useEffect(() => {
    if (
      selectedMember?.home_state?.id &&
      selectedMember?.home_county?.id &&
      selectedMember?.home_city?.id
    ) {
      fetchZipCodes(
        selectedMember.home_state.id,
        selectedMember.home_county.id,
        selectedMember?.home_city?.id,
      );
    }
  }, [selectedMember]);

  useEffect(() => {
    if (selectedMember && selectedMember?.mailing_state?.id) {
      fetchMailingCounties(selectedMember?.mailing_state?.id);
    }
  }, [selectedMember]);

  useEffect(() => {
    if (
      selectedMember &&
      selectedMember?.mailing_state?.id &&
      selectedMember?.mailing_county?.id
    ) {
      fetchMailingCities(
        selectedMember?.mailing_state?.id,
        selectedMember?.mailing_county?.id,
      );
    }
  }, [selectedMember]);

  useEffect(() => {
    if (
      selectedMember &&
      selectedMember?.mailing_state?.id &&
      selectedMember?.mailing_county?.id &&
      selectedMember?.mailing_city?.id
    ) {
      fetchMailingZipCodes(
        selectedMember?.mailing_state?.id,
        selectedMember?.mailing_county?.id,
        selectedMember?.mailing_city?.id,
      );
    }
  }, [selectedMember]);

  useEffect(() => {
    if (
      selectedMember?.mailing_street === selectedMember?.home_street &&
      selectedMember?.mailing_state?.id === selectedMember?.home_state?.id &&
      selectedMember?.mailing_county?.id === selectedMember?.home_county?.id &&
      selectedMember
    ) {
      setIsMailingSameAsHome(true);
    }
  }, [selectedMember]);
  useEffect(() => {
    if (selectedMember && selectedMember?.housing_database?.id) {
      const propertyId = selectedMember.housing_database.id;

      fetchUnits(propertyId);
    }
  }, [selectedMember]);
  const debouncedHealthPlansDataCallback = useDebouncedHealthPlansDataCallback();
  const debouncedStatesDataCallback = useDebouncedStatesDataCallback();
  const debouncedCoutiesDataCallback = useDebouncedCountiesDataCallback();
  const debouncedCitiesDataCallback = useDebouncedCitiesDataCallback();
  const debouncedHousingNavigatorDataCallback = useDebouncedHousingNavigatorDataCallback();
  const debouncedCaseManagerCallback = useDebouncedCaseManagerDataCallback();
  const debouncedZipCodesDataCallback = useDebouncedZipCodesDataCallback();
  const debouncedPropertiesDataCallback = useDebouncedPropertiesDataCallback();
  const debounceUnitsDataCallBack = useDebouncedUnitsDataCallback();
  const debounceLandlordDataCallBack = useDebouncedLandloadDataCallback();
  const [isMailingSameAsHome, setIsMailingSameAsHome] = useState(false);
  const MailingAddressSync = () => {
    const { values, setFieldValue } = useFormikContext();

    useEffect(() => {
      if (isMailingSameAsHome) {
        setFieldValue("mailing_address", values.home_address);
        setFieldValue("mailing_state_id", values.state_id);
        setFieldValue("mailing_county_id", values.county_id);
        setFieldValue("mailing_city_id", values.city_id);
        setFieldValue("mailing_zip_code_id", values.zip_code_id);

        setMailingStatesList(statesList);
        setMailingCountiesList(countiesList);
        setMailingCitiesList(citiesList);
        setMailingZipCodesList(zipCodesList);
      }
    }, [
      isMailingSameAsHome,
      values.home_address,
      values.state_id,
      values.county_id,
      values.city_id,
      values.zip_code_id,
      setFieldValue,
      statesList,
      countiesList,
      citiesList,
      zipCodesList,
    ]);

    return null;
  };

  return (
    <Formik
      initialValues={memberInitialValues(selectedMember)}
      validationSchema={memberSchema}
      enableReinitialize
      onSubmit={(values, { setErrors }) => {
        const {
          home_address,
          city_id,
          state_id,
          county_id,
          zip_code_id,
          mailing_address,
          mailing_city_id,
          mailing_state_id,
          mailing_county_id,
          mailing_zip_code_id,
          population_focus,
          conditions,
          date_of_birth,
          ...filteredValues
        } = values;
        const formattedDateOfBirth = date_of_birth
          ? (() => {
              const d = new Date(date_of_birth);
              const y = d.getFullYear();
              const m = String(d.getMonth() + 1).padStart(2, "0");
              const day = String(d.getDate()).padStart(2, "0");
              return `${y}/${m}/${day}`;
            })()
          : "";
        const addresses_attributes = [
          {
            ...(homeAddress?.id && { id: homeAddress.id }),
            street: home_address,
            city: city_id?.label || "",
            state: state_id?.label || "",
            county: county_id?.label || "",
            zip_code: zip_code_id?.label || "",
            zip_code_id: zip_code_id?.value || "",
            city_id: city_id?.value || "",
            state_id: state_id?.value || "",
            county_id: county_id?.value || "",
            address_type: "home",
            primary: true,
          },
          {
            ...(mailingAddress?.id && { id: mailingAddress.id }),
            street: mailing_address,
            city: mailing_city_id?.label || "",
            state: mailing_state_id?.label || "",
            county: mailing_county_id?.label || "",
            zip_code: mailing_zip_code_id?.label || "",
            city_id: mailing_city_id?.value || "",
            state_id: mailing_state_id?.value || "",
            county_id: mailing_county_id?.value || "",
            zip_code_id: mailing_zip_code_id?.value || "",
            address_type: "mailing",
            primary: false,
          },
        ];

        handleQuestionSubmittion(
          {
            ...filteredValues,
            date_of_birth: formattedDateOfBirth,
            addresses_attributes,
            city_id: city_id?.value || "",
            state_id: state_id?.value || "",
            county_id: county_id?.value || "",
            housing_database_id: values?.housing_database?.value,
            housing_database: values?.housing_database?.label,
            population_focus: population_focus
              .map((item) => item.value)
              .join(","),
            conditions: conditions.map((item) => item.value).join(","),
          },
          setErrors,
        );
      }}
    >
      {({
        handleChange,
        values,
        handleSubmit,
        errors,
        setFieldValue,
        isSubmitting,
      }) => {
        return (
          <div className="question-modal">
            <form className="form-main" onSubmit={handleSubmit}>
              <hr className="custom-modal-line mt-0 " />
              <h4 className=" my-4">Personal Info</h4>
              <div className="input-flex row">
                <div className="col-sm-4">
                  <Input
                    isRequired
                    handleChange={handleChange}
                    placeholder="e.g. John Doe"
                    type="text"
                    label="First Name"
                    value={values.first_name}
                    name="first_name"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="first_name"
                      />
                    }
                  />
                </div>

                <div className="col-sm-4">
                  <Input
                    isRequired
                    handleChange={handleChange}
                    placeholder="e.g. John Doe"
                    type="text"
                    label="Last Name"
                    value={values.last_name}
                    name="last_name"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="last_name"
                      />
                    }
                  />
                </div>
                <div className="col-sm-4">
                  <DateInput
                    isRequired
                    handleChange={(date) =>
                      setFieldValue("date_of_birth", date)
                    }
                    value={values.date_of_birth}
                    label="Select Date of Birth"
                    name="date_of_birth"
                    placeholder="Date of Birth"
                    isValidDate={disableFutureDates}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="date_of_birth"
                      />
                    }
                  />
                </div>
              </div>
              <div className="input-flex row">
                <div className="col-sm-4">
                  <SelectComponent
                    label="Gender"
                    selectedValue={values.gender}
                    options={GENDER}
                    placeholder="Select Gender"
                    handleChange={(obj) => {
                      setFieldValue("gender", obj.value);
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="gender"
                      />
                    }
                  />
                </div>
                <div className="col-sm-4">
                  <SelectComponent
                    label="Race/Ethnicity"
                    options={RACES}
                    selectedValue={values.race}
                    placeholder="Select Race/Ethnicity"
                    handleChange={(obj) => {
                      setFieldValue("race", obj.value);
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="race"
                      />
                    }
                  />
                </div>
                <div className="col-sm-4">
                  <SelectComponent
                    label="Marital Status"
                    options={MARTIAL_STATUSES}
                    selectedValue={values.marital}
                    placeholder="Select Marital Status"
                    handleChange={(obj) => {
                      setFieldValue("marital", obj.value);
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="marital"
                      />
                    }
                  />
                </div>
                <div className="col-sm-4">
                  <AsyncSelect
                    label="Health Plan"
                    isRequired
                    options={
                      healthPlansList?.length > 0
                        ? healthPlansList.map((el) => ({
                            value: el.id,
                            label: el.name,
                          }))
                        : selectedMember?.health_plan
                        ? [
                            {
                              value: selectedMember.health_plan.id,
                              label: selectedMember.health_plan.name,
                            },
                          ]
                        : []
                    }
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debouncedHealthPlansDataCallback(inputValue, resolve);
                      })
                    }
                    selectedValue={values.health_plan_id}
                    placeholder="Select Health Plan"
                    onChange={(obj) => {
                      setFieldValue("health_plan_id", obj?.value || "");
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="health_plan_id"
                      />
                    }
                  />
                </div>
              </div>
              <h4 className=" my-4">Membership Info</h4>
              <div className="input-flex row">
                <div className="col-sm-6">
                  <Input
                    isRequired
                    handleChange={handleChange}
                    placeholder="e.g. CIN7438201"
                    type="text"
                    label="CIN"
                    value={values.cin}
                    name="cin"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="cin"
                      />
                    }
                  />
                </div>
                <div className="col-sm-6">
                  <Input
                    handleChange={handleChange}
                    placeholder="e.g. AICA256849317"
                    type="text"
                    label="AICA Master Person Index No."
                    value={values.aica_account}
                    name="aica_account"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="aica_account"
                      />
                    }
                  />
                </div>
              </div>
              <div className="input-flex row">
                <div className="col-sm-6">
                  <Input
                    isRequired
                    handleChange={handleChange}
                    placeholder="e.g. KIPU123456"
                    type="text"
                    label="KIPU Account No"
                    value={values.kipu_account_no}
                    name="kipu_account_no"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="kipu_account_no"
                      />
                    }
                  />
                </div>
                {/* <div className="col-sm-6">
                  <Input
                    handleChange={handleChange}
                    placeholder="e.g. SUB1009876543"
                    type="text"
                    label="Subscriber ID"
                    value={values.subscriber_id}
                    name="subscriber_id"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="subscriber_id"
                      />
                    }
                  />
                </div> */}
                {/* <div className="col-sm-6"> */}
                {/* <div className="col-sm-6">
                  <Input
                    isRequired
                    handleChange={handleChange}
                    placeholder="e.g. KIPU123456789"
                    type="text"
                    label="KIPU IFMRN"
                    value={values.kipu_ifmrn}
                    name="kipu_ifmrn"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="kipu_ifmrn"
                      />
                    }
                  />
                </div> */}

                <div className="col-sm-6">
                  <AsyncSelect
                    label="CSS Manager"
                    isRequired
                    options={(caseManger.find(
                      (el) => el.id === selectedMember.case_manager,
                    ) || typeof selectedMember.case_manager === "undefined"
                      ? caseManger
                      : [
                          ...caseManger,
                          selectedMember.case_manager && {
                            id: selectedMember.case_manager?.id,
                            full_name: `${selectedMember.case_manager
                              ?.first_name ?? ""} ${selectedMember.case_manager
                              ?.last_name ?? ""}`.trim(),
                          },
                        ]
                    )
                      ?.filter(Boolean)
                      ?.map((el) => ({
                        value: el?.id,
                        label: el?.full_name ?? "",
                      }))
                      ?.sort((a, b) =>
                        (a.label || "").localeCompare(b.label || ""),
                      )}
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debouncedCaseManagerCallback(inputValue, resolve);
                      })
                    }
                    selectedValue={values.case_manager_id}
                    placeholder="Select CSS Manager"
                    handleChange={(obj) => {
                      setFieldValue("case_manager_id", obj.value);
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="case_manager_id"
                      />
                    }
                  />
                </div>
                <div className="col-sm-6">
                  <AsyncSelect
                    label="Housing Navigator"
                    isRequired
                    options={(housingNavigator.find(
                      (el) => el.id === selectedMember.housing_navigator,
                    ) || typeof selectedMember.housing_navigator === "undefined"
                      ? housingNavigator
                      : [
                          ...housingNavigator,
                          selectedMember.housing_navigator && {
                            id: selectedMember.housing_navigator?.id,
                            full_name: `${selectedMember.housing_navigator
                              ?.first_name ?? ""} ${selectedMember
                              .housing_navigator?.last_name ?? ""}`.trim(),
                          },
                        ]
                    )
                      ?.filter(Boolean)
                      ?.map((el) => ({
                        value: el?.id,
                        label: el?.full_name ?? "",
                      }))
                      ?.sort((a, b) =>
                        (a.label || "").localeCompare(b.label || ""),
                      )}
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debouncedHousingNavigatorDataCallback(
                          inputValue,
                          resolve,
                        );
                      })
                    }
                    selectedValue={values.housing_navigator}
                    placeholder="Select Housing Navigator"
                    handleChange={(obj) => {
                      setFieldValue("housing_navigator", obj.value);
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="housing_navigator"
                      />
                    }
                  />
                </div>
              </div>
              <h4 className=" my-4">Program Enrollment</h4>
              <div
                className="program-enrollment-grid"
                style={{ marginBottom: "20px" }}
              >
                <div
                  className="row"
                  style={{
                    fontWeight: "bold",
                    marginBottom: "10px",
                    backgroundColor: "#f8f9fa",
                    padding: "10px",
                    borderRadius: "5px",
                  }}
                >
                  <div className="col-sm-6">
                    <span>Program</span>
                  </div>
                  <div className="col-sm-3">
                    <span>Status</span>
                  </div>
                  <div className="col-sm-3">
                    <span>IF MRN Number</span>
                  </div>
                </div>

                {CALAIM_PROGRAMS.map((program, index) => (
                  <div
                    key={program.id}
                    className="row"
                    style={{ marginBottom: "10px", alignItems: "center" }}
                  >
                    <div
                      className="col-sm-6"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingTop: "8px",
                      }}
                    >
                      <span style={{ fontSize: "14px" }}>{program.name}</span>
                    </div>

                    <div className="col-sm-3">
                      <SelectComponent
                        options={PROGRAM_STATUS_OPTIONS}
                        selectedValue={
                          values[program.statusField] || "inactive"
                        }
                        placeholder="Select Status"
                        handleChange={(obj) => {
                          setFieldValue(program.statusField, obj.value);
                          // ❌ removed clearing IF MRN
                        }}
                        error={
                          <ErrorMessage
                            className="error-message"
                            component="p"
                            name={program.statusField}
                          />
                        }
                      />
                    </div>

                    <div className="col-sm-3">
                      <Input
                        handleChange={handleChange}
                        placeholder="e.g. 12345"
                        type="text"
                        value={values[program.ifmrnField]}
                        name={program.ifmrnField}
                        disabled={values[program.statusField] !== "active"}
                        error={
                          <ErrorMessage
                            className="error-message"
                            component="p"
                            name={program.ifmrnField}
                          />
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>

              <h4 className=" my-4">Contact Info</h4>
              <div className="input-flex row">
                <div className="col-sm-6">
                  <Input
                    handleChange={(e) => {
                      const formattedNumber = normalizeInput(e.target.value);
                      setFieldValue("phone_number", formattedNumber);
                    }}
                    placeholder="e.g. 555-123-4567"
                    type="text"
                    label="Phone"
                    value={values.phone_number}
                    name="phone_number"
                    className="mb-1"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="phone_number"
                      />
                    }
                  />
                </div>
                <div className="col-sm-6">
                  <Input
                    handleChange={handleChange}
                    placeholder="e.g. johndoe@gmail.com"
                    type="email"
                    label="Email"
                    value={values.email}
                    name="email"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="email"
                      />
                    }
                  />
                </div>
              </div>
              <div className="input-flex row">
                <div className="col-sm-6">
                  <Input
                    handleChange={handleChange}
                    placeholder="e.g. 1234 Main St."
                    type="text"
                    label="Home Address"
                    value={values.home_address}
                    name="home_address"
                    className="mb-1"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="home_address"
                      />
                    }
                  />
                </div>
                <div className="col-sm-6">
                  <AsyncSelect
                    label="Home State"
                    isRequired
                    options={
                      statesList.find(
                        (plan) => plan.id === selectedMember?.state_id,
                      ) || typeof selectedMember?.state_id == "undefined"
                        ? [
                            ...statesList?.map((el) => {
                              return {
                                value: el.id,
                                label: el.name.toUpperCase(),
                              };
                            }),
                          ]
                        : [
                            ...statesList?.map((el) => {
                              return { value: el.id, label: el.name };
                            }),
                            {
                              value: selectedMember.state?.id,
                              label: selectedMember.state?.name,
                            },
                          ]
                    }
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debouncedStatesDataCallback(inputValue, resolve);
                      })
                    }
                    selectedValue={values.state_id}
                    placeholder="Select State "
                    handleChange={(obj) => {
                      // setStateId(obj.value);
                      setFieldValue("state_id", obj);
                      setFieldValue("county_id", "");
                      setFieldValue("city_id", "");
                      setFieldValue("zip_code_id", "");
                      fetchCounties(obj.value);
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="state_id"
                      />
                    }
                  />
                </div>
                <div className="col-sm-6">
                  <AsyncSelect
                    selectedValue={values.county_id}
                    label="Home County"
                    disabled={values.state_id ? false : true}
                    isRequired
                    options={
                      countiesList.find(
                        (plan) => plan.id === selectedMember.county_id,
                      ) || typeof selectedMember.county_id == "undefined"
                        ? [
                            ...countiesList?.map((el) => {
                              return {
                                value: el.id,
                                label: capitalizeName(el.name),
                              };
                            }),
                          ]
                        : [
                            ...countiesList?.map((el) => {
                              return {
                                value: el.id,
                                label: capitalizeName(el.name),
                              };
                            }),
                            {
                              value: selectedMember.county?.id,
                              label: capitalizeName(
                                selectedMember.county?.name,
                              ),
                            },
                          ]
                    }
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debouncedCoutiesDataCallback(
                          inputValue,
                          values.state_id?.value,
                          resolve,
                        );
                      })
                    }
                    placeholder="Select County "
                    handleChange={(obj) => {
                      setFieldValue("county_id", obj);
                      setFieldValue("city_id", "");
                      setFieldValue("zip_code_id", "");
                      fetchCities(values.state_id?.value, obj.value);
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="county_id"
                      />
                    }
                  />
                </div>
                <div className="col-sm-6">
                  <AsyncSelect
                    label="Home City"
                    // disabled={values.county_id ? false : true}
                    options={citiesList.map((el) => ({
                      value: el.id,
                      label: capitalizeName(el.name),
                    }))}
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debouncedCitiesDataCallback(
                          inputValue,
                          values.state_id?.value,
                          values.county_id?.value,
                          resolve,
                        );
                      })
                    }
                    selectedValue={values?.city_id}
                    placeholder="Select City"
                    handleChange={(obj) => {
                      setFieldValue("city_id", obj);
                      setFieldValue("zip_code_id", "");
                      fetchZipCodes(
                        values.state_id?.value,
                        values.county_id?.value,
                        obj.value,
                      );
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="city_id"
                      />
                    }
                  />
                </div>
                <div className="col-sm-12">
                  <AsyncSelect
                    name="zip_code_id"
                    label="Home ZIP Code"
                    disabled={!values.city_id}
                    options={
                      zipCodesList.find(
                        (plan) => plan.id === selectedMember?.zip_code_id,
                      ) || typeof selectedMember?.zip_code_id === "undefined"
                        ? zipCodesList?.map((el) => ({
                            value: el.id,
                            label: el.name,
                          }))
                        : [
                            ...zipCodesList?.map((el) => ({
                              value: el.id,
                              label: el.name,
                            })),
                            {
                              value: selectedMember.zip_code?.id,
                              label: selectedMember.zip_code?.name,
                            },
                          ]
                    }
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debouncedZipCodesDataCallback(
                          inputValue,
                          values.state_id?.value,
                          values.county_id?.value,
                          values.city_id?.value,
                          resolve,
                        );
                      })
                    }
                    selectedValue={values.zip_code_id}
                    handleChange={(obj) => setFieldValue("zip_code_id", obj)}
                    className="mb-1"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="zip_code_id"
                      />
                    }
                  />
                </div>
                <MailingAddressSync />
                <div className="col-sm-12 mb-3">
                  <label className="d-flex align-items-center">
                    <input
                      type="checkbox"
                      checked={isMailingSameAsHome}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setIsMailingSameAsHome(isChecked);

                        if (!isChecked) {
                          setFieldValue("mailing_address", "");
                          setFieldValue("mailing_state_id", "");
                          setFieldValue("mailing_county_id", "");
                          setFieldValue("mailing_city_id", "");
                          setFieldValue("mailing_zip_code_id", "");
                          setMailingCountiesList([]);
                          setMailingCitiesList([]);
                          setMailingZipCodesList([]);
                        }
                      }}
                      className="me-2 form-check-input light-grey-background"
                    />
                    Mailing Address same as Home Address
                  </label>
                </div>

                {!isMailingSameAsHome && (
                  <>
                    <div className="col-sm-6">
                      <Input
                        handleChange={handleChange}
                        placeholder="e.g. 1234 Main St."
                        type="text"
                        label="Mailing Address"
                        value={values.mailing_address}
                        name="mailing_address"
                        className="mb-1"
                        error={
                          <ErrorMessage
                            className="error-message"
                            component="p"
                            name="mailing_address"
                          />
                        }
                      />
                    </div>
                    <div className="col-sm-6">
                      <AsyncSelect
                        label="Mailing State"
                        options={
                          mailingStatesList.find(
                            (plan) => plan.id === mailingAddress?.state_id,
                          ) || typeof mailingAddress?.state_id == "undefined"
                            ? [
                                ...mailingStatesList?.map((el) => {
                                  return {
                                    value: el.id,
                                    label: el.name.toUpperCase(),
                                  };
                                }),
                              ]
                            : [
                                ...mailingStatesList?.map((el) => {
                                  return { value: el.id, label: el.name };
                                }),
                                {
                                  value: mailingAddress?.state_id,
                                  label: mailingAddress?.state_name,
                                },
                              ]
                        }
                        loadOptions={(inputValue) =>
                          new Promise((resolve) => {
                            debouncedStatesDataCallback(inputValue, resolve);
                          })
                        }
                        selectedValue={values.mailing_state_id}
                        placeholder="Select State "
                        handleChange={(obj) => {
                          // setStateId(obj.value);
                          setFieldValue("mailing_state_id", obj);
                          setFieldValue("mailing_county_id", "");
                          setFieldValue("mailing_city_id", "");
                          setFieldValue("mailing_zip_code_id", "");
                          fetchMailingCounties(obj.value);
                        }}
                        error={
                          <ErrorMessage
                            className="error-message"
                            component="p"
                            name="mailing_state_id"
                          />
                        }
                      />
                    </div>
                    <div className="col-sm-6">
                      <AsyncSelect
                        selectedValue={values.mailing_county_id}
                        label="Mailing County"
                        disabled={values.mailing_state_id ? false : true}
                        options={
                          mailingCountiesList.find(
                            (plan) => plan.id === mailingAddress?.county_id,
                          ) || typeof mailingAddress?.county_id == "undefined"
                            ? [
                                ...mailingCountiesList?.map((el) => {
                                  return {
                                    value: el.id,
                                    label: capitalizeName(el.name),
                                  };
                                }),
                              ]
                            : [
                                ...mailingCountiesList?.map((el) => {
                                  return {
                                    value: el.id,
                                    label: capitalizeName(el.name),
                                  };
                                }),
                                {
                                  value: mailingAddress?.county_id,
                                  label: capitalizeName(
                                    mailingAddress?.county_name,
                                  ),
                                },
                              ]
                        }
                        loadOptions={(inputValue) =>
                          new Promise((resolve) => {
                            debouncedCoutiesDataCallback(
                              inputValue,
                              values.mailing_state_id?.value,
                              resolve,
                            );
                          })
                        }
                        placeholder="Select County "
                        handleChange={(obj) => {
                          setFieldValue("mailing_county_id", obj);
                          setFieldValue("mailing_city_id", "");
                          setFieldValue("mailing_zip_code_id", "");
                          fetchMailingCities(
                            values.mailing_state_id?.value,
                            obj.value,
                          );
                        }}
                        error={
                          <ErrorMessage
                            className="error-message"
                            component="p"
                            name="mailing_county_id"
                          />
                        }
                      />
                    </div>
                    <div className="col-sm-6">
                      <AsyncSelect
                        label="Mailing City"
                        disabled={values.mailing_county_id ? false : true}
                        options={mailingCitiesList.map((el) => ({
                          value: el.id,
                          label: capitalizeName(el.name),
                        }))}
                        loadOptions={(inputValue) =>
                          new Promise((resolve) => {
                            debouncedCitiesDataCallback(
                              inputValue,
                              values.mailing_state_id?.value,
                              values.mailing_county_id?.value,
                              resolve,
                            );
                          })
                        }
                        selectedValue={values?.mailing_city_id}
                        placeholder="Select City"
                        handleChange={(obj) => {
                          setFieldValue("mailing_city_id", obj);
                          setFieldValue("mailing_zip_code_id", "");
                          fetchMailingZipCodes(
                            values.mailing_state_id?.value,
                            values.mailing_county_id?.value,
                            obj.value,
                          );
                        }}
                        error={
                          <ErrorMessage
                            className="error-message"
                            component="p"
                            name="mailing_city_id"
                          />
                        }
                      />
                    </div>
                    <div className="col-sm-12">
                      <AsyncSelect
                        name="mailing_zip_code_id"
                        label="Mailing ZIP Code"
                        disabled={!values.mailing_city_id}
                        options={
                          mailingZipCodesList.find(
                            (plan) =>
                              plan.id === selectedMember?.mailing_zip_code_id,
                          ) ||
                          typeof selectedMember?.mailing_zip_code_id ===
                            "undefined"
                            ? mailingZipCodesList?.map((el) => ({
                                value: el.id,
                                label: el.name,
                              }))
                            : [
                                ...mailingZipCodesList?.map((el) => ({
                                  value: el.id,
                                  label: el.name,
                                })),
                                {
                                  value: selectedMember.zip_code?.id,
                                  label: selectedMember.zip_code?.name,
                                },
                              ]
                        }
                        loadOptions={(inputValue) =>
                          new Promise((resolve) => {
                            debouncedZipCodesDataCallback(
                              inputValue,
                              values.state_id?.value,
                              values.county_id?.value,
                              values.city_id?.value,
                              resolve,
                            );
                          })
                        }
                        selectedValue={values.mailing_zip_code_id}
                        handleChange={(obj) =>
                          setFieldValue("mailing_zip_code_id", obj)
                        }
                        className="mb-1"
                        error={
                          <ErrorMessage
                            className="error-message"
                            component="p"
                            name="mailing_zip_code_id"
                          />
                        }
                      />
                    </div>
                  </>
                )}
              </div>
              <h4 className=" my-4">Emergency Contact</h4>
              <div className="input-flex row">
                <div className="col-sm-6">
                  <Input
                    handleChange={handleChange}
                    placeholder="e.g. John Smith"
                    type="text"
                    label="Emergency Contact Name"
                    value={values.emergency_contact_name}
                    name="emergency_contact_name"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="emergency_contact_name"
                      />
                    }
                  />
                </div>
                <div className="col-sm-6">
                  <SelectComponent
                    label="Emergency Contact Relationship"
                    options={EMERGENCY_CONTACT_RELATIONSHIPS}
                    selectedValue={values.emergency_contact_relationship}
                    placeholder="Select Relationship"
                    handleChange={(obj) => {
                      setFieldValue(
                        "emergency_contact_relationship",
                        obj.value,
                      );
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="emergency_contact_relationship"
                      />
                    }
                  />
                </div>
              </div>
              <h4 className=" my-4">Communication Preferences</h4>
              <div className="input-flex row">
                <div className="col-sm-6">
                  <Input
                    isRequired
                    handleChange={handleChange}
                    placeholder="e.g. English"
                    type="text"
                    label="Preferred Language Spoken"
                    value={values.preferred_spoken_language}
                    name="preferred_spoken_language"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="preferred_spoken_language"
                      />
                    }
                  />
                </div>
                <div className="col-sm-6">
                  <Input
                    handleChange={handleChange}
                    placeholder="e.g. Chinese"
                    type="text"
                    label="Preferred Language Written"
                    value={values.preferred_written_language}
                    name="preferred_written_language"
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="preferred_written_language"
                      />
                    }
                  />
                </div>
              </div>
              <h4 className=" my-4">Other</h4>
              <div className="input-flex row">
                <div className="col-sm-6">
                  <SelectComponent
                    name="population_focus"
                    label="Population of Focus"
                    options={POPULATION_FOCUSES}
                    selectedValue={values.population_focus}
                    isMulti
                    placeholder="Select Population of Focus"
                    handleChange={(arr) => {
                      setFieldValue("population_focus", arr);
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="population_focus"
                      />
                    }
                  />
                </div>
                <div className="col-sm-6">
                  <AsyncSelect
                    label="Conditions"
                    name="conditions"
                    options={CONDITIONS}
                    selectedValue={values.conditions}
                    isMulti
                    placeholder="Select Conditions"
                    handleChange={(arr) => {
                      setFieldValue("conditions", arr);
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="conditions"
                      />
                    }
                  />
                </div>
              </div>
              <h4 className=" my-4">Property Information</h4>
              <div className="input-flex row">
                <div className="col-sm-4">
                  <AsyncSelect
                    label="Property"
                    options={
                      propertiesList?.map((el) => ({
                        value: el.id,
                        label: el.property_name,
                      })) || []
                    }
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debouncedPropertiesDataCallback(inputValue, resolve);
                      })
                    }
                    selectedValue={values.housing_database}
                    name="housing_database"
                    placeholder="Select Property"
                    handleChange={(obj) => {
                      setFieldValue("housing_database", obj);
                      setFieldValue("housing_unit", "");
                      setFieldValue("landlord_name", "");
                      if (obj?.value) {
                        fetchUnits(obj.value);
                      }
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="housing_database"
                      />
                    }
                  />
                </div>
                <div className="col-sm-4">
                  <AsyncSelect
                    label="Unit"
                    disabled={!values.housing_database}
                    options={
                      unitsList?.map((el) => ({
                        value: el.id,
                        label: capitalizeName(el.type_of_unit),
                      })) || []
                    }
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debounceUnitsDataCallBack(
                          inputValue,
                          values?.housing_database?.value,
                          resolve,
                        );
                      })
                    }
                    selectedValue={values.housing_unit}
                    placeholder="Select Unit"
                    handleChange={(obj) => {
                      setFieldValue("housing_unit", obj.label);
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="housing_unit"
                      />
                    }
                  />
                </div>
                <div className="col-sm-4">
                  <AsyncSelect
                    label="Landlord Name"
                    disabled={!values.housing_database}
                    options={
                      landlordsList?.map((el) => ({
                        value: el.id,
                        label: el.name,
                      })) || []
                    }
                    loadOptions={(inputValue) =>
                      new Promise((resolve) => {
                        debounceLandlordDataCallBack(
                          inputValue,
                          values?.housing_database?.value,
                          resolve,
                        );
                      })
                    }
                    selectedValue={values.landlord_name}
                    placeholder="Select Landlord"
                    handleChange={(obj) => {
                      setFieldValue("landlord_name", obj.label);
                    }}
                    error={
                      <ErrorMessage
                        className="error-message"
                        component="p"
                        name="landlord_name"
                      />
                    }
                  />
                </div>
              </div>
              <hr className="custom-modal-line mt-4 " />
              <div className="action gap-2">
                <button
                  className="secondary-btn w-50"
                  type="button"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <input
                  className="primary-btn w-50"
                  type="submit"
                  name="submit"
                  value={`${selectedMember ? "Edit" : "Add"} Member`}
                />
              </div>
            </form>
          </div>
        );
      }}
    </Formik>
  );
};

export default AddQuestionForm;
